import classNames from 'classnames/bind';
import { useState } from 'react';
import Icon from '../../Icon/Icon';
import { IconName } from '../../Icon/utils/types';
import styles from './NavLink.module.scss';

const cx = classNames.bind(styles);

interface NavLinkProps {
    step: number;
    title: string;
    disabled?: boolean;
    inactive?: boolean;
    showArrow?: boolean;
    onClick?: () => void;
}

const NavLink = (props: NavLinkProps) => {
    const { step, title, disabled, inactive, showArrow, onClick } = props;

    const [isHovered, setIsHovered] = useState(false);

    const handleClick = () => {
        if(disabled){
            return;
        }
        onClick && onClick();
    }

    return (
        <div 
            onMouseEnter={() => !disabled && setIsHovered(true)} 
            onMouseLeave={() => !disabled && setIsHovered(false)} 
            className={cx('nav-link', { 'nav-link--disabled': disabled })}
            onClick={handleClick}
        >
            <div className={cx('nav-link__step', { 'nav-link__step--disabled': disabled, 'nav-link__step--hovered': isHovered })}>
                <span className={cx('nav-link__step-number')}>{step}</span>
            </div>
            <span className={cx('nav-link__title', { 'nav-link__title--inactive': inactive, 'nav-link__title--disabled': disabled, 'nav-link__title--hovered': isHovered })}>{title}</span>
            {showArrow && (
                <Icon className={cx('nav-link__arrow', { 'nav-link__arrow--disabled': disabled, 'nav-link__arrow--hovered': isHovered })} name={IconName.NavArrow} width={8} height={16} />
            )}
        </div>
    );
};

export default NavLink;